import { LoginCallback, LogoutCallback } from '@myosh/myosh-login';
import { Navigate, Route, Routes } from 'react-router';
import { LoginPage } from '@/pages/login.page';
import { MainPage } from '@/pages/main.page';
import { PrivateRoute } from '@/routes/private-route';

export const App = () => (
  <Routes>
    <Route path="/auth/cb/logout" element={<LogoutCallback />} />
    <Route path="/auth/cb/silent" element={null} />
    <Route path="/auth/cb" element={<LoginCallback />} />
    <Route path="/login" element={<LoginPage />} />
    <Route path="/" element={<PrivateRoute />}>
      <Route index element={<MainPage />} />
    </Route>
    <Route path="*" element={<Navigate to="/" replace />} />
  </Routes>
);
